@if (selectedItem) {
  <form [formGroup]="form" (ngSubmit)="save(selectedItem)" >
    <p-panel>
      <p-header>
        @if (selectedItem.id) {
          <h2>Editing '{{originalName}}'</h2>
        }
        @if (!selectedItem.id) {
          <h2>Create New {{entityName}}</h2>
        }
      </p-header>
      <div class="grid flex-row flex-wrap">
        <!-- Item specifics start here -->
        <p-panel lass="col-9 flex-auto">
          <p-header>Company info</p-header>
          <div class="col-12 flex-auto grid flex-row flex-wrap">
            <div class="col-4 flex-auto">
              <mat-form-field class="full-width"  [color]="!form.controls.number.valid ? 'warn' : 'primary'">
                <mat-label>Number</mat-label>
                <input matInput class="full-width" type="text" id="number" formControlName="number" required/>
                @if (!form.controls.number.valid) {
                  <mat-hint align="start" [class.alert-danger]="!form.controls.number.valid">Company number must not be empty</mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="col-8 flex-auto">
              <mat-form-field class="full-width" [color]="!form.controls.name.valid ? 'warn' : 'primary'">
                <mat-label>Company name</mat-label>
                <input matInput class="full-width" type="text" id="name" formControlName="name" required />
                @if (!form.controls.name.valid) {
                  <mat-hint align="start" [class.alert-danger]="!form.controls.name.valid">Company name must not be empty</mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="col-4 flex-auto">
              <mat-form-field class="full-width">
                <mat-label>Roepnaam</mat-label>
                <input matInput type="text" id="description" formControlName="description" />
              </mat-form-field>
            </div>
            <div class="col-8 flex-auto">
              <mat-form-field class="full-width">
                <mat-label>Email address</mat-label>
                <input matInput type="text" id="email" formControlName="email" />
              </mat-form-field>
            </div>
          </div>
        </p-panel>
        <p-panel class="col-3 flex-auto">
          <p-header>Blacklist</p-header>
          <node-blacklisting class="full-width" [form]="$any(form.controls.blacklisting)"></node-blacklisting>
        </p-panel>
        <!-- Item specifics end here -->
      </div>
      @if (errorMsgs?.length) {
        <ul class="alert alert-danger">
          @for (err of errorMsgs; track err) {
            <li>{{err}}</li>
          }
        </ul>
      }
      <p-footer>
        <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">Submit</button>
        <button mat-raised-button (click)="cancel(selectedItem)" type="button">Cancel</button>
      </p-footer>
    </p-panel>
  </form>
}

@if (!selectedItem) {
  <div>{{entityName}} does not exists</div>
}

